export const ITEM_TYPE = {
    ELEMENT: 'element',
  };